import { EntityType, TabKeys } from 'UI/constants/entityTypes';

const hiringAuthorityApiVersion = 2;

export const createTabsProps = ({
  createSendoutsProps: { handleSendoutClick, shouldRefreshTableData },
  endpoint,
  hiringAuthorityName,
  isLoading,
  itemName,
  location,
  onActivityComplete,
  profileId,
  profileName,
  refreshData,
  results,
  searchProjectsProps
}) => [
  {
    id: TabKeys.Companies,
    tabProps: {
      onCompaniesChanged: refreshData,
      profileId,
      endpoint,
      profileName,
      location
    }
  },
  {
    id: TabKeys.JobOrders,
    tabProps: {
      profileId: results?.id,
      isLoading,
      itemName,
      mode: EntityType.HiringAuthority
    }
  },
  searchProjectsProps,
  {
    id: TabKeys.Sendouts,
    tabProps: {
      profile: results,
      profileModule: EntityType.Candidate,
      onSendoutClick: handleSendoutClick,
      shouldRefresh: shouldRefreshTableData
    }
  },
  {
    id: TabKeys.ActivityLogs,
    tabProps: {
      itemName: hiringAuthorityName,
      apiVersion: hiringAuthorityApiVersion,
      profileId: results?.id,
      profileModule: EntityType.HiringAuthority,
      onActivityComplete,
      endpoint
    }
  },
  {
    id: TabKeys.Notes,
    tabProps: {
      itemName: hiringAuthorityName,
      apiVersion: hiringAuthorityApiVersion,
      profileId: results?.id,
      profileModule: EntityType.HiringAuthority,
      endpoint
    }
  },
  {
    id: TabKeys.Tasks,
    tabProps: {
      itemName,
      profileId
    }
  }
];
